<template>
  <Head title="Pathway Mapping Template Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <pathway-mapping-template-list :templates="templates"></pathway-mapping-template-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  templates: Array
});
</script>

